import {
  countries
} from '../helpers/countries';
import {
  applicantFields,
  legalGuardianFields,
  primaryApplicantStudentFields,
  premiumField,
  studentNumberFields,
  overridePremiumFields,
  splitPolicyButton
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'lloydsetrstudent';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.pmqGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
    fieldGroups.viewMemberPortalGroup(),
    fieldGroups.magentaAccessGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      ...primaryApplicantStudentFields(),
    ],
    contact_details_fields: [
      ...legalGuardianFields(true)
    ],
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'dependent',
          text: 'Dependent Child'
        },
        {
          value: 'parent',
          text: 'Parent/Guardian'
        },
        {
          value: 'spouse',
          text: 'Spouse'
        }
      ]),
      ...studentNumberFields('*'),
      ...splitPolicyButton()
    ],
    coverage_fields: [
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries()
      },
      {
        key_path: ['application', 'additional_data', 'overall_maximum_limit'],
        as: 'Overall Maximum Limit',
        type: 'dropdown',
        options: [
          { value: '50000', text: '$50,000.00 CAD' },
        ],
      },
      {
        key_path: ['application', 'additional_data', 'other_plan'],
        as: 'Other Insurance',
        type: 'dropdown',
        options: [
          { value: 'yes', text: 'Yes' },
          { value: 'no', text: 'No' }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'name_of_other_plan'],
        as: 'Name of Other Plan',
        show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: 'yes'
        }]
      }
    ],
    payment_fields: overridePremiumFields()
  }
}



// WEBPACK FOOTER //
// ./src/clients/lloydsetrstudent.js